import { inject, provideAppInitializer } from '@angular/core'
import { Location } from '@angular/common'

import { getLocalStorage, removeLocalStorage, STORAGE_KEYS } from '@utils/storage'
import { UrlParameters, UrlParametersState } from '@states/url-parameters'
import { AppRoutes } from '@enums/app-routes'

export const urlParamsInitializer = provideAppInitializer(() => {
	const location = inject(Location)
	const urlParametersState = inject(UrlParametersState)
	const urlParams = getLocalStorage<UrlParameters>(STORAGE_KEYS.URL_PARAMETERS)
	const currentUrl = location.path()

	if (currentUrl !== AppRoutes.Payment) {
		removeLocalStorage(STORAGE_KEYS.URL_PARAMETERS)

		return
	}

	urlParametersState.urlParameters.set(urlParams)
})
